'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_GroupNameInput$() {
}
export { $c_Lpresto_GroupNameInput$ as $c_Lpresto_GroupNameInput$ };
$p = $c_Lpresto_GroupNameInput$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_GroupNameInput$;
/** @constructor */
function $h_Lpresto_GroupNameInput$() {
}
export { $h_Lpresto_GroupNameInput$ as $h_Lpresto_GroupNameInput$ };
$h_Lpresto_GroupNameInput$.prototype = $p;
$p.cAt = (function(name) {
  var $x_5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.ff();
  var $x_4 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$();
  var $x_3 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.g.h("p-4 border");
  var $x_2 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.eV().y("text");
  var $x_1 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.Tv().y("Nome do grupo");
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$();
  var updater = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.jq().aJ(name.sN());
  var listener = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_EventListener(($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_keys_EventProcessor$().W($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_api_package$().a.lm(), false, false)).r7(), new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((str) => {
    name.my(str);
  })));
  return $x_5.d($x_4.c(new ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$d_Lcom_raquo_laminar_modifiers_Modifier.r().C)([$x_3, $x_2, $x_1, $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_inputs_InputController$().yY(listener, updater)])));
});
var $d_Lpresto_GroupNameInput$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_GroupNameInput$, "presto.GroupNameInput$", ({
  IS: 1
}));
export { $d_Lpresto_GroupNameInput$ as $d_Lpresto_GroupNameInput$ };
var $n_Lpresto_GroupNameInput$;
function $m_Lpresto_GroupNameInput$() {
  if ((!$n_Lpresto_GroupNameInput$)) {
    $n_Lpresto_GroupNameInput$ = new $c_Lpresto_GroupNameInput$();
  }
  return $n_Lpresto_GroupNameInput$;
}
export { $m_Lpresto_GroupNameInput$ as $m_Lpresto_GroupNameInput$ };
//# sourceMappingURL=presto.-Group-Name-Input$.js.map
